__turbopack_context__.v({
  "accessory": "disclosure-module___9sabG__accessory",
  "body": "disclosure-module___9sabG__body",
  "caret": "disclosure-module___9sabG__caret",
  "count": "disclosure-module___9sabG__count",
  "detail": "disclosure-module___9sabG__detail",
  "icon": "disclosure-module___9sabG__icon",
  "label": "disclosure-module___9sabG__label",
  "root": "disclosure-module___9sabG__root",
  "toggle": "disclosure-module___9sabG__toggle",
});
